import React, { useEffect, useState } from "react";
import {
  clientDetailsApi,
  profileStatusUpdateApi,
  recordViewCountApi,
} from "../apis/customer/customer-apis";
import moment from "moment";
import { useParams } from "react-router-dom";
import errorToast from "../utils/toast/errorToast";
import { useFormik } from "formik";
import * as Yup from "yup";
import successToast from "../utils/toast/successToast";
import navbarLogo from "../assets/navbar-logo.png";

const ProfileViewPage = () => {
  const params = useParams();
  const [details, setdetails] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [profileView, setProfileView] = useState(false);
  const isSignature = details?.subscriptionData?.type_of_client === "signature";
  const [showPhoneModal, setshowPhoneModal] = useState(true);
  const [onStatusUpdate, setonStatusUpdate] = useState(true);

  const fetchDetails = async () => {
    try {
      const res = await clientDetailsApi({
        id: params?.id,
      });
      if (res.status === 200) {
        setdetails(res?.data?.data);
      }
    } catch (error) {
      errorToast("Please try again later");
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  useEffect(() => {
    if (details?.customerImages?.length > 0) {
      setGallery(details?.customerImages);
    }
  }, [details]);

  const nextImage = () => {
    setPreviewIndex((prev) => (prev + 1) % gallery.length);
  };

  const prevImage = () => {
    setPreviewIndex((prev) => (prev === 0 ? gallery.length - 1 : prev - 1));
  };

  const name = details?.name;
  const nameParts = name?.split(" ");

  const maritalStatusOptions = [
    {
      label: "Never married",
      value: "never_married",
    },
    {
      label: "Divorced",
      value: "divorced",
    },
    {
      label: "Widowed",
      value: "widowed",
    },
    {
      label: "Annulled",
      value: "annulled",
    },
    {
      label: "separated",
      value: "separated",
    },
    {
      label: "Awaiting divorce",
      value: "awaiting_divorce",
    },
    {
      label: "Other",
      value: "other",
    },
  ];

  const getmarriedOptions = [
    {
      label: "6 months",
      value: "6_months",
    },
    {
      label: "1 year",
      value: "1_year",
    },
    {
      label: "No timeline",
      value: "no_timeline",
    },
  ];

  const propertyTypeOptions = [
    {
      label: "Own",
      value: "own",
    },
    {
      label: "Rented",
      value: "rented",
    },
    {
      label: "Leased",
      value: "leased",
    },
    {
      label: "Dont want to disclose",
      value: "dont_want_to_disclose",
    },
  ];

  const dietPreferenceOptions = [
    {
      label: "Veg",
      value: "veg",
    },
    {
      label: "Non veg",
      value: "non_veg",
    },
    {
      label: "Vegan",
      value: "vegan",
    },
    {
      label: "Eggetarian",
      value: "eggetarian",
    },
    {
      label: "dont want to disclose",
      value: "dont_want_to_disclose",
    },
  ];

  const educationPriority = {
    phd: 6,
    Masters: 5, // Note: Matches your array's casing
    bachelors: 4,
    diploma: 3,
    "12th": 2,
    school: 1,
  };

  const highestEducation =
    details?.educationDetails?.length > 0
      ? details?.educationDetails?.reduce((prev, current) => {
          const prevRank = educationPriority[prev.type] || 0;
          const currentRank = educationPriority[current.type] || 0;

          return currentRank > prevRank ? current : prev;
        })
      : "--";

  return (
    <div className={isSignature ? "black-body" : "white-body"}>
      {showPhoneModal && (
        <PhoneModal onClose={() => setshowPhoneModal(false)} />
      )}
      {onStatusUpdate && (
        <ActionTab
          profileId={params?.id}
          onSuccess={() => setonStatusUpdate(false)}
        />
      )}
      {/* IMAGE MODAL */}
      {previewIndex !== null && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
          <button
            onClick={() => setPreviewIndex(null)}
            className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white text-2xl sm:text-3xl"
          >
            ×
          </button>

          <button
            onClick={prevImage}
            className="absolute left-2 sm:left-6 text-white text-3xl sm:text-4xl"
          >
            ‹
          </button>

          <img
            src={gallery[previewIndex]?.image_url}
            alt="Preview"
            className="max-h-[80vh] max-w-[80vw] w-full object-contain rounded-lg"
            style={{ imageRendering: "auto" }}
          />

          <button
            onClick={nextImage}
            className="absolute right-2 sm:right-6 text-white text-3xl sm:text-4xl"
          >
            ›
          </button>
        </div>
      )}

      {profileView && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
          <button
            onClick={() => setProfileView(false)}
            className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white text-2xl sm:text-3xl"
          >
            ×
          </button>

          <img
            src={details?.profile_bio_url}
            alt="Preview"
            className="max-h-[80vh] max-w-[80vw] w-full object-contain rounded-lg"
          />
        </div>
      )}

      <div
        className={
          isSignature ? "cover signature-theme" : "cover regular-theme"
        }
      >
        {/* Dynamic cover background */}
        <div className={isSignature ? "cover-bg" : "reg-cover-bg"}></div>

        {/* Dynamic geometry wrapper */}
        <div
          className={
            isSignature ? "cover-geo signature-geo" : "cover-geo reg-geo"
          }
        >
          <svg
            viewBox="0 0 1400 900"
            preserveAspectRatio="xMidYMid slice"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0"
              y1="120"
              x2="80"
              y2="120"
              stroke={
                isSignature ? "rgba(201,168,76,0.12)" : "rgba(255,255,255,0.12)"
              }
              strokeWidth="1"
            />
            <line
              x1="120"
              y1="0"
              x2="120"
              y2="80"
              stroke={
                isSignature ? "rgba(201,168,76,0.12)" : "rgba(255,255,255,0.12)"
              }
              strokeWidth="1"
            />
            <line
              x1="0"
              y1="160"
              x2="60"
              y2="160"
              stroke={
                isSignature ? "rgba(201,168,76,0.06)" : "rgba(255,255,255,0.06)"
              }
              strokeWidth="0.5"
            />
            <line
              x1="160"
              y1="0"
              x2="160"
              y2="60"
              stroke={
                isSignature ? "rgba(201,168,76,0.06)" : "rgba(255,255,255,0.06)"
              }
              strokeWidth="0.5"
            />
            <line
              x1="800"
              y1="0"
              x2="1400"
              y2="400"
              stroke={
                isSignature ? "rgba(201,168,76,0.04)" : "rgba(255,255,255,0.04)"
              }
              strokeWidth="1"
            />
            <line
              x1="900"
              y1="0"
              x2="1400"
              y2="350"
              stroke={
                isSignature
                  ? "rgba(201,168,76,0.025)"
                  : "rgba(255,255,255,0.025)"
              }
              strokeWidth="0.5"
            />
            <line
              x1="1400"
              y1="780"
              x2="1320"
              y2="780"
              stroke={
                isSignature ? "rgba(201,168,76,0.12)" : "rgba(255,255,255,0.12)"
              }
              strokeWidth="1"
            />
            <line
              x1="1280"
              y1="900"
              x2="1280"
              y2="820"
              stroke={
                isSignature ? "rgba(201,168,76,0.12)" : "rgba(255,255,255,0.12)"
              }
              strokeWidth="1"
            />
            <circle
              cx="700"
              cy="450"
              r="300"
              stroke={
                isSignature ? "rgba(201,168,76,0.02)" : "rgba(255,255,255,0.02)"
              }
              strokeWidth="1"
              strokeDasharray="4 8"
            />
            <circle
              cx="700"
              cy="450"
              r="400"
              stroke={
                isSignature
                  ? "rgba(201,168,76,0.015)"
                  : "rgba(255,255,255,0.015)"
              }
              strokeWidth="0.5"
            />
          </svg>
        </div>

        {/* Dynamic Topbar wrapper */}
        <div
          className={
            isSignature
              ? "cover-topbar signature-topbar"
              : "cover-topbar reg-topbar"
          }
        >
          {isSignature ? (
            <div className="cover-topbar-inner">
              <div
                className={
                  isSignature
                    ? "cover-logo signature-logo"
                    : "cover-logo reg-logo"
                }
              >
                <svg
                  width="320"
                  height="103"
                  viewBox="0 0 560 180"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient
                      id="dlg"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop
                        offset="0%"
                        stopColor={isSignature ? "#FAF0B0" : "#FFFFFF"}
                      />
                      <stop
                        offset="40%"
                        stopColor={isSignature ? "#D4A83C" : "#E5E5E5"}
                      />
                      <stop
                        offset="100%"
                        stopColor={isSignature ? "#9A7820" : "#999999"}
                      />
                    </linearGradient>
                    <linearGradient
                      id="dlfill"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop
                        offset="0%"
                        stopColor={isSignature ? "#E8C84A" : "#CCCCCC"}
                      />
                      <stop
                        offset="100%"
                        stopColor={isSignature ? "#9A7820" : "#666666"}
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M 80 8 L 152 80 L 80 152 L 8 80 Z"
                    fill="none"
                    stroke="url(#dlg)"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M 80 40 L 120 80 L 80 120 L 40 80 Z"
                    fill="url(#dlfill)"
                  />
                  <line
                    x1="80"
                    y1="8"
                    x2="80"
                    y2="40"
                    stroke="url(#dlg)"
                    strokeWidth="0.8"
                    opacity="0.6"
                  />
                  <line
                    x1="152"
                    y1="80"
                    x2="120"
                    y2="80"
                    stroke="url(#dlg)"
                    strokeWidth="0.8"
                    opacity="0.6"
                  />
                  <line
                    x1="80"
                    y1="152"
                    x2="80"
                    y2="120"
                    stroke="url(#dlg)"
                    strokeWidth="0.8"
                    opacity="0.6"
                  />
                  <line
                    x1="8"
                    y1="80"
                    x2="40"
                    y2="80"
                    stroke="url(#dlg)"
                    strokeWidth="0.8"
                    opacity="0.6"
                  />
                  <line
                    x1="174"
                    y1="20"
                    x2="174"
                    y2="160"
                    stroke={
                      isSignature
                        ? "rgba(201,168,76,0.22)"
                        : "rgba(255,255,255,0.22)"
                    }
                    strokeWidth="0.8"
                  />
                  <text
                    x="185"
                    y="68"
                    fontFamily="Cormorant Garamond, Georgia, serif"
                    fontSize="38"
                    fontWeight="400"
                    letterSpacing="5"
                    fill="url(#dlg)"
                  >
                    House of Alliances
                  </text>
                  <line
                    x1="194"
                    y1="80"
                    x2="554"
                    y2="80"
                    stroke={
                      isSignature
                        ? "rgba(201,168,76,0.22)"
                        : "rgba(255,255,255,0.22)"
                    }
                    strokeWidth="0.7"
                  />
                  <text
                    x="185"
                    y="108"
                    fontFamily="Cormorant Garamond, Georgia, serif"
                    fontSize="16"
                    fontStyle="italic"
                    letterSpacing="2.5"
                    fill={
                      isSignature
                        ? "rgba(201,168,76,0.55)"
                        : "rgba(255,255,255,0.55)"
                    }
                  >
                    Where Distinguished Families Meet Their Equals
                  </text>
                </svg>
              </div>

              <div className="cover-topbar-right">
                {details?.mandate_level && (
                  <div
                    className={
                      isSignature
                        ? "mandate-flag signature-flag"
                        : "mandate-flag reg-flag"
                    }
                  >
                    {details?.mandate_level === "Mandate_1"
                      ? "Mandate I"
                      : details?.mandate_level === "Mandate_2"
                        ? "Mandate II"
                        : details?.mandate_level === "Mandate_3"
                          ? "Mandate III"
                          : details?.mandate_level === "Mandate_3"
                            ? "Mandate IV"
                            : ""}
                  </div>
                )}
                <div
                  className={
                    isSignature
                      ? "cover-profile-id signature-id"
                      : "cover-profile-id reg-id"
                  }
                >
                  HOA / {details?.customer_code}
                </div>
              </div>
            </div>
          ) : (
            <div className="cover-topbar-inner">
              <div
                className={
                  isSignature
                    ? "cover-logo signature-logo"
                    : "cover-logo reg-logo"
                }
              >
                <div className="flex items-center gap-3">
                  <img src={navbarLogo} alt="vip" width={100} height={30} />{" "}
                  <h1
                    class="hidden md:block"
                    style={{
                      fontFamily: "Cormorant Garamond, Georgia, serif",
                      fontSize: "20px",
                      fontWeight: 400,
                      letterSpacing: "5px",
                      margin: 0,
                      background: "linear-gradient(135deg, #d4af37, #f7e7ce)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    VIP MATRIMONIAL SERVICES
                  </h1>
                </div>
              </div>

              <div className="cover-topbar-right">
                {details?.mandate_level && (
                  <div
                    className={
                      isSignature
                        ? "mandate-flag signature-flag"
                        : "mandate-flag reg-flag"
                    }
                  >
                    {details?.mandate_level === "Mandate_1"
                      ? "Mandate I"
                      : details?.mandate_level === "Mandate_2"
                        ? "Mandate II"
                        : details?.mandate_level === "Mandate_3"
                          ? "Mandate III"
                          : details?.mandate_level === "Mandate_3"
                            ? "Mandate IV"
                            : ""}
                  </div>
                )}
                <div
                  className={
                    isSignature
                      ? "cover-profile-id signature-id"
                      : "cover-profile-id reg-id"
                  }
                >
                  VMS / {details?.customer_code}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Main content layout */}
        <div
          className={
            isSignature
              ? "cover-split signature-split"
              : "cover-split reg-split"
          }
        >
          <div className="cover-split-inner">
            <div
              className={
                isSignature
                  ? "cover-left signature-left"
                  : "cover-left reg-left"
              }
            >
              <div
                className={`cover-issue ${isSignature ? "text-[#ddb84a]" : "text-white"}`}
              >
                Profile No. {details?.customer_code}
                {/* &nbsp;·&nbsp; Confidential
                &nbsp;·&nbsp; */}
              </div>

              <div
                className={`cover-name flex flex-wrap gap-x-2 lg:block pb-5 ${
                  isSignature ? "text-[#ddb84a]" : "text-white"
                }`}
              >
                {nameParts?.[0]}
                <span className="hidden lg:block"></span>
                <span>{nameParts?.[1]}</span>
                {nameParts?.length > 2 && (
                  <>
                    <span className="hidden lg:block"></span>
                    {nameParts?.slice(2)?.join(" ")}
                  </>
                )}
              </div>

              <div
                className={
                  isSignature
                    ? "cover-byline signature-byline"
                    : "cover-byline reg-byline"
                }
              >
                {details?.casteDetails?.name} · {details?.workingCity?.name}
              </div>

              {/* Info list grid */}
              <div
                className={`flex border-t border-b py-[20px] flex-wrap gap-5 `}
                style={{ borderColor: "var(--b2)" }}
              >
                {[
                  { val: details?.age ?? "-", lbl: "Age" },
                  {
                    val: details?.height ? `${details.height}"` : "-",
                    lbl: "Height",
                  },
                  {
                    val: highestEducation?.institution ?? "-",
                    lbl: "Education",
                  },

                  {
                    val:
                      details?.manglik_status === "yes"
                        ? "Manglik"
                        : details?.manglik_status === "no"
                          ? "Not Manglik"
                          : details?.manglik_status === "partial_anshik"
                            ? "Partial Anshik"
                            : "-",
                    lbl: "Horoscope",
                  },
                  { val: details?.casteDetails?.name ?? "-", lbl: "Community" },
                ].map((item, index) => (
                  <div
                    className={
                      isSignature
                        ? "cs-item signature-item"
                        : "cs-item reg-item"
                    }
                    key={index}
                  >
                    <div
                      className={`cs-val ${isSignature ? "text-[#edd080]" : "text-white"}`}
                    >
                      {item.val}
                    </div>
                    <div
                      className={
                        isSignature
                          ? "cs-lbl signature-lbl text-[#edd080]"
                          : "cs-lbl reg-lbl text-white"
                      }
                    >
                      {item.lbl}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Portrait / Slot panel */}
            <div
              className={
                isSignature
                  ? "cover-right signature-right"
                  : "cover-right reg-right"
              }
            >
              <div
                className={
                  isSignature
                    ? "cover-portrait-slot signature-slot"
                    : "cover-portrait-slot reg-slot"
                }
              >
                {details?.profile_bio_url ? (
                  <img
                    id="cover-photo-img"
                    alt="Client Photo"
                    src={details?.profile_bio_url}
                    onClick={() => setProfileView(true)}
                    className={
                      isSignature
                        ? "cover-photo-img signature-img"
                        : "cover-photo-img reg-img"
                    }
                  />
                ) : (
                  <div
                    className={
                      isSignature
                        ? "cover-portrait-empty signature-empty"
                        : "cover-portrait-empty reg-empty"
                    }
                    id="cover-portrait-empty"
                  >
                    <div
                      className={`cover-portrait-mono ${isSignature ? "text-[#edd080]" : "text-white"}`}
                    >
                      AVM
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*═══════════ THE CANDIDATE ═══════════  */}

      <div className="sec-divider">
        <div className="inner">
          <div className="sd-line"></div>
          <div className="sd-ornament">The Candidate</div>
          <div className="sd-line"></div>
        </div>
      </div>

      <div className="section">
        <div className="inner">
          <div
            className={isSignature ? "editorial-block" : "reg-editorial-block"}
          >
            {/* LEFT COLUMN: Quote and Personal Stats */}
            <div className={isSignature ? "eb-left" : "reg-eb-left"}>
              <div>
                <div
                  className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
                >
                  Personal
                </div>
                <div className="fd-row three">
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Date of Birth
                    </div>
                    <div
                      className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                    >
                      {details?.date_of_birth
                        ? moment(details?.date_of_birth).format("DD MMMM YYYY")
                        : "-"}
                    </div>
                  </div>
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Gender
                    </div>
                    <div
                      className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                    >
                      {details?.gender
                        ? details?.gender == "male"
                          ? "Male"
                          : "Female"
                        : "-"}
                    </div>
                  </div>
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Age
                    </div>
                    <div
                      className={`fv large ${isSignature ? "text-[#edd080]" : "text-[#1A4A72]"}`}
                    >
                      {details?.age ?? "-"}
                    </div>
                  </div>
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Height
                    </div>
                    <div
                      className={`fv large ${isSignature ? "text-[#edd080]" : "text-[#1A4A72]"}`}
                    >
                      {details?.height ?? "-"}
                    </div>
                  </div>
                </div>

                <div className="fd-row" style={{ marginTop: "14px" }}>
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Nationality
                    </div>
                    <div
                      className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                    >
                      {details?.nationalityDetails?.name ?? "-"}
                    </div>
                  </div>
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Mother Tongue
                    </div>
                    <div
                      className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                    >
                      {details?.mother_tongue ?? "-"}
                    </div>
                  </div>
                </div>

                <div className="fd-row" style={{ marginTop: "10px" }}>
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Marital Status
                    </div>
                    <div
                      className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                    >
                      {details?.marital_status
                        ? maritalStatusOptions?.find(
                            (item) => item?.value === details?.marital_status,
                          )?.label
                        : "-"}
                    </div>
                  </div>
                  <div className="fd">
                    <div
                      className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                    >
                      Currently Based
                    </div>
                    <div
                      className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                    >
                      {details?.workingState?.name}
                      {details?.workingCountry?.name
                        ? ", " + details?.workingCountry?.name
                        : "-"}
                    </div>
                  </div>
                </div>

                {details?.health_conditions && (
                  <div style={{ marginTop: "10px" }}>
                    <div className="fd">
                      <div
                        className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                      >
                        Health condition
                      </div>
                      <div
                        className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                      >
                        {details?.health_condition_description ?? "-"}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* RIGHT COLUMN: Bio and Community */}
            <div className={isSignature ? "eb-right" : "eb-right bg-white"}>
              <div
                className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
              >
                About {details?.name}
              </div>
              <div
                className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                style={{ marginBottom: "20px" }}
              >
                {details?.about_me}
              </div>

              <div
                className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
              >
                Community &amp; Horoscope
              </div>
              <div className="fd-row ">
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Religion
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.religionDetails?.name ?? "-"}
                  </div>
                </div>
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Community
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.casteDetails?.name ?? "-"}
                  </div>
                </div>
              </div>

              <div className="fd-row" style={{ marginTop: "10px" }}>
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    SUB caste
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.subcaste ?? "-"}
                  </div>
                </div>
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Gotra
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.gotra ?? "-"}
                  </div>
                </div>
              </div>

              <div className="fd-row" style={{ marginTop: "10px" }}>
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Manglik Status
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                    // style={{ color: "var(--green3)" }}
                  >
                    {details?.manglik_status === "yes"
                      ? "Manglik"
                      : details?.manglik_status === "no"
                        ? "✓ Not Manglik"
                        : details?.manglik_status === "partial_anshik"
                          ? "Partial Anshik"
                          : "-"}
                  </div>
                </div>
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Time of Birth
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.time_of_birth
                      ? moment(
                          `${details.date_of_birth} ${details.time_of_birth}`,
                        ).format("hh:mm A")
                      : "-"}
                  </div>
                </div>
                <div className="fd capitalize">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Place of Birth
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.place_of_birth ?? "-"}
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div
                  className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  style={{ marginBottom: "8px" }}
                >
                  Lifestyle
                </div>
                <div className="chip-row">
                  {details?.diet_preference === "veg" ? (
                    <span className="chip gold">Vegetarian</span>
                  ) : details?.diet_preference === "non_veg" ? (
                    <span className="chip gold">Non Vegetarian</span>
                  ) : details?.diet_preference === "vegan" ? (
                    <span className="chip gold">Vegan</span>
                  ) : details?.diet_preference === "eggetarian" ? (
                    <span className="chip gold">Eggetarian</span>
                  ) : (
                    ""
                  )}

                  {details?.smoking_habit === "no" ? (
                    <span className="chip">Non-Smoker</span>
                  ) : details?.smoking_habit === "occasionally" ? (
                    <span className="chip">Occasional Smoker</span>
                  ) : details?.smoking_habit === "regularly" ? (
                    <span className="chip">Regular Smoker</span>
                  ) : (
                    ""
                  )}

                  {details?.drinking_habit === "no" ? (
                    <span className="chip">Non-Drinker</span>
                  ) : details?.drinking_habit === "occasionally" ? (
                    <span className="chip">Occasional Drinker</span>
                  ) : details?.drinking_habit === "regularly" ? (
                    <span className="chip">Regular Drinker</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div style={{ marginTop: "20px" }}>
                <div
                  className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  style={{ marginBottom: "8px" }}
                >
                  Hobbies
                </div>
                <div
                  className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                >
                  {details?.hobbies ?? "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════ CLIENT PHOTOS ═══════════  */}
      {details?.customerImages?.length > 0 && (
        <div>
          <div className="sec-divider">
            <div className="inner">
              <div className="sd-line"></div>
              <div className="sd-ornament">Client Photos</div>
              <div className="sd-line"></div>
            </div>
          </div>
          <div className="photos-section">
            <div className="inner">
              <div className="photo-secondary">
                {details?.customerImages?.length > 0 && (
                  <>
                    {details?.customerImages?.map((item, index) => (
                      <div
                        key={index}
                        className="photo-sec-slot"
                        id="slot-candid"
                      >
                        {item?.image_url ? (
                          <img
                            onClick={() => setPreviewIndex(index)}
                            id="cover-photo-img"
                            alt="Client Photo"
                            src={item?.image_url}
                            className="cover-photo-img"
                          />
                        ) : (
                          <div className="photo-empty">
                            <div className="photo-empty-mono">AVM</div>
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}

                {/* Candid Slot */}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════ EDUCATION & CAREER ═══════════ */}
      <div className="sec-divider">
        <div className="inner">
          <div className="sd-line"></div>
          <div className="sd-ornament">Education &amp; Career</div>
          <div className="sd-line"></div>
        </div>
      </div>
      <div className="section">
        <div className="inner">
          <div className="highlight-panel">
            <div class="grid md:grid-cols-2 gap-8">
              <div>
                <div
                  className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                >
                  Current Role
                </div>
                <div
                  style={{
                    fontFamily: '"Cormorant Garamond", serif',
                    fontSize: "1.6rem",
                    fontWeight: 600,
                    lineHeight: 1.1,
                    margin: "6px 0",
                  }}
                  className={`${isSignature ? "text-[#edd080]" : "text-[#1A4A72]"}`}
                >
                  {details?.currentProfessionDetails?.name ?? "-"}
                </div>

                <div
                  style={{
                    fontSize: "14px",
                    marginTop: "4px",
                  }}
                  className={`${isSignature ? "text-[#8a7a5a]" : "text-[#1A4A72]"}`}
                >
                  {details?.workingCity?.name}
                  {details?.workingCity?.name
                    ? ", " + details?.workingState?.name
                    : (details?.workingState?.name ?? "")}
                  {details?.workingState?.name
                    ? ", " + details?.workingCountry?.name
                    : (details?.workingCountry?.name ?? "")}
                </div>
              </div>

              {details?.willing_to_relocate_abroad !== "no" && (
                <div>
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Willing to relocate abroad
                  </div>
                  <div
                    style={{
                      fontFamily: '"Cormorant Garamond", serif',
                      fontSize: "16px",
                      fontWeight: 600,
                      lineHeight: 1.1,
                      margin: "6px 0",
                    }}
                    className={`${isSignature ? "text-[#edd080]" : "text-[#1A4A72]"}`}
                  >
                    {details?.willing_to_relocate_abroad === "yes"
                      ? "Yes"
                      : details?.willing_to_relocate_abroad === "depends"
                        ? "Depends"
                        : "-"}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="editorial-block">
            <div className={isSignature ? "eb-left" : "reg-eb-left"}>
              <div
                className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
              >
                Education
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {details?.educationDetails?.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      paddingBottom: "20px",
                      borderBottom: "1px solid var(--b1)",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: '"Cormorant Garamond", serif',
                        fontSize: "1.2rem",
                        // color: "var(--text)",
                        fontWeight: 600,
                      }}
                      className={`${isSignature ? "text-[#ead8b0]" : "text-[#1A4A72]"}`}
                    >
                      {item?.institution}
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        // color: "var(--gold2)",
                        marginTop: "2px",
                      }}
                      className={`${isSignature ? "text-[#ddb84a]" : "text-[#1A4A72]"}`}
                    >
                      {item?.qualification}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={isSignature ? "eb-right" : "eb-right bg-white"}>
              <div
                className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
              >
                Career
              </div>
              <div
                className={`fv ${isSignature ? "text-[#a89870]" : "text-[#1A4A72]"}`}
                style={{ marginBottom: "20px" }}
              >
                {details?.about_profession ?? "--"}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════ THE FAMILY ═══════════ */}
      <div className="sec-divider">
        <div className="inner">
          <div className="sd-line"></div>
          <div className="sd-ornament">The Family</div>
          <div className="sd-line"></div>
        </div>
      </div>
      <div className="section">
        <div className="inner">
          <div className="grid md:grid-cols-2 gap-4 mb-6">
            {/* Father's Panel */}
            <div className="highlight-panel" style={{ marginBottom: 0 }}>
              <div
                style={{
                  fontFamily: '"Cormorant Garamond", serif',
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
                className={`capitalize ${isSignature ? "text-[#ead8b0]" : "text-[#1A4A72]"}`}
              >
                {details?.father_name} — Father
              </div>
              <div
                style={{
                  fontSize: "14px",
                  lineHeight: 1.7,
                }}
                className={`${isSignature ? "text-[#a89870]" : "text-[#1A4A72]"}`}
              >
                {details?.fatherProfession?.name}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  // color: "var(--text3)",
                  lineHeight: 1.7,
                  fontStyle: "italic",
                }}
                className={`${isSignature ? "text-[#a89870]" : "text-[#1A4A72]"}`}
              >
                {details?.father_about}
              </div>
            </div>

            {/* Mother's Panel */}
            <div className="highlight-panel" style={{ marginBottom: 0 }}>
              <div
                style={{
                  fontFamily: '"Cormorant Garamond", serif',
                  fontSize: "1.1rem",
                  // color: "var(--text)",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
                className={`capitalize ${isSignature ? "text-[#ead8b0]" : "text-[#1A4A72]"}`}
              >
                {details?.mother_name} — Mother
              </div>
              <div
                style={{
                  fontSize: "14px",
                  lineHeight: 1.7,
                }}
                className={`${isSignature ? "text-[#a89870]" : "text-[#1A4A72]"}`}
              >
                {details?.motherProfession?.name}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  // color: "var(--text3)",
                  lineHeight: 1.7,
                  fontStyle: "italic",
                }}
                className={`${isSignature ? "text-[#a89870]" : "text-[#1A4A72]"}`}
              >
                {details?.mother_about}
              </div>
            </div>
          </div>

          <div className="editorial-block">
            {/* LEFT COLUMN: Background & Wealth */}
            <div className={isSignature ? "eb-left" : "reg-eb-left"}>
              <div
                className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
              >
                Family Background
              </div>
              <div className="fd-row">
                {/* <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Family Type
                  </div>
                  <div
                    className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    Joint (Functionally nuclear)
                  </div>
                </div> */}
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Native Place
                  </div>
                  <div
                    className={`fv capitalize ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.native_place ?? "-"}
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN: Siblings & Connections */}

            <div className={isSignature ? "eb-right" : "eb-right bg-white"}>
              {details?.siblings?.length > 0 && (
                <>
                  <div
                    className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
                  >
                    Siblings
                  </div>
                  {details?.siblings?.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "16px 0",
                        borderBottom: "1px solid var(--b1)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                          // color: "var(--text2)",
                        }}
                        className={`${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                      >
                        {item?.name} ({item?.age})
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          // color: "var(--text3)",
                          marginTop: "4px",
                          fontStyle: "italic",
                        }}
                        className={`${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                      >
                        {item?.about}
                      </div>
                    </div>
                  ))}{" "}
                </>
              )}

              {details?.relatives?.length > 0 && (
                <>
                  <div
                    className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
                  >
                    Relatives
                  </div>
                  {details?.relatives?.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "16px 0",
                        borderBottom: "1px solid var(--b1)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                          // color: "var(--text2)",
                        }}
                        className={`${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                      >
                        {item?.name}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          // color: "var(--text3)",
                          marginTop: "4px",
                          fontStyle: "italic",
                        }}
                        className={`${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                      >
                        {item?.about}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════ BUSINESS & ASSETS ═══════════  */}

      <div className="sec-divider">
        <div className="inner">
          <div className="sd-line"></div>
          <div className="sd-ornament">Business &amp; Assets</div>
          <div className="sd-line"></div>
        </div>
      </div>

      <div className="section">
        <div className="inner">
          <div className="asset-grid">
            {details?.businessInformation?.map((item, index) => (
              <div key={index} className="asset-item">
                <div
                  className={`${isSignature ? "text-[#edd080]" : "text-[#1A4A72]"} ai-val capitalize`}
                >
                  {item?.name ?? "-"}
                </div>
                <div
                  className={`${isSignature ? "text-[#8a7a5a]" : "text-[#1A4A72]"} ai-lbl capitalize`}
                  style={{ fontSize: "14px" }}
                >
                  {item?.status ?? "-"}
                </div>
                <div
                  className={`${isSignature ? "text-[#8a7a5a]" : "text-[#1A4A72]"} ai-detail capitalize`}
                  style={{ fontSize: "14px" }}
                >
                  {item?.about ?? "-"}
                </div>
              </div>
            ))}
          </div>

          <div className="" style={{ marginBottom: 0 }}>
            {/* LEFT COLUMN: Residence Details */}
            <div className={isSignature ? "eb-left" : "reg-eb-left "}>
              <div
                className={`fg-title ${isSignature ? "text-[#c02050]" : "text-[#8B6030]"}`}
              >
                Residence Details
              </div>
              <div class="grid md:grid-cols-2 gap-8">
                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Family Home
                  </div>
                  <div
                    className={`fv capitalize ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.parentCity?.name}
                    {details?.parentCity?.name
                      ? ", " + details?.parentState?.name
                      : (details?.parentState?.name ?? "")}
                    {details?.parentState?.name
                      ? ", " + details?.parentCountry?.name
                      : (details?.parentCountry?.name ?? "")}
                    .
                  </div>
                  <div
                    className={`fv capitalize ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.parents_permanent_address ?? "-"}
                  </div>
                </div>

                <div className="fd">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Ownership
                  </div>
                  <div
                    className={`fv capitalize ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.parents_property_type ?? "-"}
                  </div>
                </div>
              </div>
              {details?.candidate_address_different && (
                <div className="fd mt-3">
                  <div
                    className={`fl ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                  >
                    Candidate address
                  </div>

                  <div
                    className={`fv capitalize ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
                  >
                    {details?.candidate_address ?? "-"}
                  </div>
                </div>
              )}
            </div>

            <div className="highlight-panel mt-3">
              <div
                className={`fg-title ${isSignature ? "text-[#c9a84c]" : "text-[#1A4A72]"}`}
                style={{ marginBottom: "12px" }}
              >
                What the Family is Looking For
              </div>
              <div
                className={`fv ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
              >
                {details?.lifestyle_compactibility_requirement}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dealbreaker-band">
        <div className="inner">
          <div className="db-icon">⚠</div>
          <div>
            <div className="db-heading">Absolute Deal-Breakers</div>
            <div className="db-items">{details?.non_negotiable_red_flag}</div>
          </div>
        </div>
      </div>

      {/* ═══════════ FOOTER ═══════════ */}
      <div className="profile-footer">
        <div className="inner">
          {isSignature ? (
            <div className="footer-hoa">◆ HOUSE OF ALLIANCES</div>
          ) : (
            <div className="flex items-center gap-3">
              <img src={navbarLogo} alt="vip" width={100} height={30} />
              <h1 class="footer-hoa">VIP MATRIMONIAL SERVICES</h1>
            </div>
          )}

          <div
            className={`footer-conf ${isSignature ? "text-[#d0bc90]" : "text-[#1A4A72]"}`}
          >
            This profile is shared in strict confidence · Not for reproduction
            or distribution · {details?.customer_code}
          </div>
          {/* <div className="footer-date">
            Registered March 2024 · Active Search
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProfileViewPage;

function PhoneModal({ onClose }) {
  const params = useParams();
  const formik = useFormik({
    initialValues: {
      id: params?.id ?? "",
      phone_number: "",
    },
    validationSchema: Yup.object({
      phone_number: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
        .required("Phone number is required"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await recordViewCountApi(values);
        if (res?.status === 200) {
          onClose();
          successToast(res.message);
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Please try again later");
      }
    },
  });

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-xl animate-fade-in"
      tabIndex="-1"
      aria-modal="true"
      role="dialog"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 scale-100"
        style={{ background: "linear-gradient(135deg, #f0ede6, #e8e4dc)" }}
      >
        {/* Header (Matching image) */}
        <div className="px-6 pt-5 pb-3 flex items-center justify-between border-b border-gray-100">
          <h3 className="text-xl font-semibold text-[#1A4A72]">
            Enter Phone Number
          </h3>
        </div>

        <form onSubmit={formik.handleSubmit} className="p-6 space-y-4">
          <div className="space-y-1.5">
            <label
              htmlFor="phone_number"
              className="block text-sm font-medium text-gray-700"
            >
              Phone Number
            </label>
            <input
              id="phone_number"
              name="phone_number"
              type="tel"
              placeholder="Enter phone number"
              value={formik.values.phone_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`w-full px-4 py-3 border rounded-xl bg-[#e8e4dc] outline-none text-gray-900 placeholder:text-[#1A4A72] transition-all ${
                formik.touched.phone_number && formik.errors.phone_number
                  ? "border-red-400 focus:ring-2 focus:ring-red-100"
                  : "border-gray-300 focus:ring-2 "
              }`}
            />
            {formik.touched.phone_number && formik.errors.phone_number && (
              <p className="text-xs text-red-600 pl-1">
                {formik.errors.phone_number}
              </p>
            )}
          </div>

          {/* Footer Actions (Matching image) */}
          <div className="pt-3 flex items-center justify-end space-x-3">
            <button
              type="submit"
              className="px-6 py-2.5 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl shadow-sm transition-colors"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ActionTab({ profileId, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const handleStatusUpdate = async (status) => {
    setLoading(true);
    try {
      const payload = {
        id: profileId,
        profile_shared_status: status,
      };

      const res = await profileStatusUpdateApi(payload);

      if (res?.status === 200) {
        successToast(
          res?.data?.message || res?.message || "Status updated successfully",
        );
        if (onSuccess) onSuccess(status);
      }
    } catch (error) {
      errorToast(error?.response?.data?.message ?? "Please try again later");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed bottom-5 right-5 z-40 flex items-center gap-3 p-2 bg-[#0B1528]/90 backdrop-blur-md border border-slate-700/60 rounded-full shadow-2xl">
      {/* Reject Button */}
      <button
        type="button"
        disabled={loading}
        onClick={() => handleStatusUpdate("declined")}
        className="flex items-center gap-2 px-5 py-2.5 rounded-full text-xs font-semibold uppercase tracking-wider text-rose-300 bg-rose-950/40 hover:bg-rose-900/60 border border-rose-800/50 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        Reject
      </button>

      {/* Vertical Separator */}
      <div className="h-6 w-[1px] bg-slate-700/60" />

      {/* Approve Button */}
      <button
        type="button"
        disabled={loading}
        onClick={() => handleStatusUpdate("accepted")}
        className="flex items-center gap-2 px-6 py-2.5 rounded-full text-xs font-semibold uppercase tracking-wider text-[#0B1528] bg-gradient-to-r from-[#E6C687] to-[#D4AF37] hover:brightness-110 shadow-lg shadow-amber-900/20 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.5"
            d="M5 13l4 4L19 7"
          />
        </svg>
        Approve
      </button>
    </div>
  );
}
